import { DeviceListingContext } from "../../Utils/DeviceListingContext";

function deviceListingContext(state = new DeviceListingContext(), action: any) {
  switch (action.type) {
    case 'DEVICE_LISTING_CONTEXT':
      console.log('Reducer::DeviceListingContext ' + action.data.context, {state, action})
      return action.data
    default:
      return state
  }
}

export { deviceListingContext }